export const handleBackTop = () => {
  if (window.location.hash) {
    window.location.hash = "/";
  }
  window.document.body.scrollIntoView({
    block: "start",
    behavior: "smooth",
  });
};
export const isDesktop = () => {
  return window.matchMedia("(min-width: 1024px)").matches;
};

export const isAndroid = () => {
  return /Android/i.test(navigator.userAgent);
};
export const isIOS = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const isIpad = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isTabletSize = window.innerWidth > 768 && window.innerWidth < 1366;

  return (
    /ipad/.test(userAgent) ||
    (navigator.platform === "MacIntel" &&
      navigator.maxTouchPoints > 0 &&
      isTabletSize)
  );
};

// Get header height based on screen size
export const getHeaderHeight = () => {
  const isMobile = window.innerWidth <= 992;
  return isMobile ? 64 : 72; // Mobile: 64px, Desktop: 72px
};

// Scroll to anchor with header offset
export const scrollToAnchor = (element, options = {}) => {
  if (!element) return;
  
  const headerHeight = getHeaderHeight();
  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
  const offsetPosition = elementPosition - headerHeight;
  
  window.scrollTo({
    top: offsetPosition,
    behavior: options.behavior || 'smooth'
  });
};
